import { render, staticRenderFns } from "./AwardLogreview.vue?vue&type=template&id=1a0ded4c&scoped=true"
import script from "./AwardLogreview.vue?vue&type=script&lang=js"
export * from "./AwardLogreview.vue?vue&type=script&lang=js"
import style0 from "./AwardLogreview.vue?vue&type=style&index=0&id=1a0ded4c&prod&lang=css"
import style1 from "./AwardLogreview.vue?vue&type=style&index=1&id=1a0ded4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0ded4c",
  null
  
)

export default component.exports